import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTasklistComponent } from "./med-icon-tasklist.component";

@NgModule({
  declarations: [
    MedIconTasklistComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTasklistComponent,
  ],
})
export class MedIconTasklistModule { }
